import tiersMutations from "./tiers.mutation";
import tiersStates from "./tiers.state";
import tiersActions from "./tiers.action";
import tiersGetters from "./tiers.getters";

export default {
  mutations: tiersMutations,
  state: tiersStates,
  actions: tiersActions,
  getters: tiersGetters
};
